"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deferToShallowerSystemId = deferToShallowerSystemId;
function shallowestSystemIdDepth(group) {
    let shallowest;
    for (const [instance, nets] of group.getNets()) {
        const depth = instance.path.length;
        if (shallowest !== undefined && depth >= shallowest) {
            continue;
        }
        for (const net of nets) {
            if (net.wires.some((w) => w.strategyMetadata?.['system-id'])) {
                shallowest = depth;
                break;
            }
        }
    }
    return shallowest;
}
function deferToShallowerSystemId(group, labelDepth) {
    if (labelDepth === undefined) {
        return false;
    }
    const systemIdDepth = shallowestSystemIdDepth(group);
    return systemIdDepth !== undefined && systemIdDepth < labelDepth;
}
//# sourceMappingURL=orcadHighestLevelWins.js.map